import React from 'react';
import '../index.css';
import farmImage from '../assets/images/farm.jpg';

const About = () => {
    return (
        <div className="min-h-screen bg-gradient-to-b from-green-50 to-white">
            {/* Hero Section with Parallax Effect */}
            <div className="relative h-80 overflow-hidden rounded-xl">
                <div 
                    className="absolute inset-0 bg-cover bg-center transform scale-110"
                    style={{ 
                        backgroundImage: `url(${farmImage})`,
                        backgroundPosition: '50% 30%'
                    }}
                ></div>
                <div className="absolute inset-0 bg-gradient-to-b from-emerald-400/40 to-teal-500/60 backdrop-blur-sm"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                    <h1 className="text-5xl font-bold text-white tracking-tight">About SphereSix</h1>
                </div>
            </div>

            {/* Content Section */}
            <div className="max-w-4xl mx-auto px-6 py-16">
                {/* Mission Card */}
                <div className="relative mb-16 rounded-2xl overflow-hidden shadow-xl">
                    <div className="absolute inset-0 bg-gradient-to-r from-emerald-400 via-green-300 to-teal-400 opacity-90"></div>
                    <div className="absolute inset-0 backdrop-blur-xl"></div>
                    <div className="relative p-8 z-10">
                        <h2 className="text-3xl font-semibold text-white mb-4">Our Mission</h2>
                        <p className="text-white/90 text-lg leading-relaxed">
                            At SphereSix, we empower small and independent farmers to participate in the carbon market with ease and confidence. By simplifying the process of generating and selling carbon credits, we help farmers turn sustainability into profitability.
                        </p>
                    </div>
                </div>

                {/* Values Section */}
                <div className="grid md:grid-cols-2 gap-8 mb-16">
                    <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
                        <div className="h-2 bg-gradient-to-r from-emerald-400 to-green-300"></div>
                        <div className="p-6">
                            <h3 className="text-xl font-semibold text-gray-800 mb-3">Addressing Challenges</h3>
                            <p className="text-gray-600">
                                We understand the challenges farmers face—lack of knowledge, trust concerns, and complex procedures. That's why we provide a transparent, user-friendly platform that delivers personalized insights and actionable solutions.
                            </p>
                        </div>
                    </div>
                    
                    <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
                        <div className="h-2 bg-gradient-to-r from-green-300 to-teal-400"></div>
                        <div className="p-6">
                            <h3 className="text-xl font-semibold text-gray-800 mb-3">Our Commitment</h3>
                            <p className="text-gray-600">
                                Our goal is to make carbon sequestration accessible, ensuring that farmers can contribute to climate action while securing a stronger financial future.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Vision Section */}
                <div className="relative rounded-2xl overflow-hidden bg-white shadow-lg p-8">
                    <div className="absolute -bottom-16 -right-16 w-64 h-64 bg-gradient-to-r from-emerald-400/20 to-teal-400/20 rounded-full blur-3xl"></div>
                    <div className="relative z-10">
                        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Our Vision</h2>
                        <p className="text-gray-600 text-lg">
                            With a commitment to innovation, trust, and economic opportunity, SphereSix is bridging the gap between agriculture and sustainability—one farm at a time.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;